import { render } from "./PromoProductsRow.vue?vue&type=template&id=4f34bfc2&scoped=true"
import script from "./PromoProductsRow.vue?vue&type=script&lang=js"
export * from "./PromoProductsRow.vue?vue&type=script&lang=js"

import "./PromoProductsRow.vue?vue&type=style&index=0&id=4f34bfc2&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f34bfc2"]])

export default __exports__